import { MetaType } from './types';

const defaultMeta: MetaType = {
    auth: 'required',
    header: true,
    nav: true,
    subRoot: '',
    title: '',
};

export {
    defaultMeta as meta,
};
